import CurrentPriceCellValue from './CurrentPriceCellValue';

export default CurrentPriceCellValue;
